import { useCallback, useState } from 'react'

const useOpenState = (initial?: boolean): [boolean, () => void, () => void] => {
  const [open, setOpen] = useState(initial != null ? initial : false)
  const handleOpen = useCallback(() => setOpen(true), [setOpen])
  const handleClose = useCallback(() => setOpen(false), [setOpen])

  return [open, handleOpen, handleClose]
}

export default useOpenState
